import "normalize.css"
import React from 'react'
import GlobalStyle from "./src/components/GlobalStyle"

require("prismjs/themes/prism-solarizedlight.css")
require("./src/styles/highlight.css")

export const wrapRootElement = ({ element }) => (
  <>
    <GlobalStyle/>
    { element }
  </>
)

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated. ` +
      `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}
